/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 

expocadfx.emailLinkBuilder = function( value) {
	'use strict';
	var config = expocadfx.config;

	var link = location.origin + location.pathname + "?";

	if( config.hasMultipleViews) {
		link += "event=" + config.viewName + "&";
	}
	if( typeof( value) === "object") {
		link += "IAH=" + value.x + "," + value.y;
	}
	else {
		link += "zoomto=" + encodeURIComponent( value);
	}
	return link;
};